// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container,
.no-user-header-container,
.help-header-container {
  display: flex;
  align-items: center;
  position: relative;
  background: #181818;
  height: 70px;
  padding: 0 2.2rem;
  box-shadow: 0 2px 16px rgba(0,0,0,0.15);
  font-family: 'Inter', Arial, sans-serif;
}

.icon-group.left,
.icon-group.right {
  flex: 1 0;
  min-width: 120px;
  display: flex;
  align-items: center;
  gap: 1.1rem;
}

.icon-group.left {
  justify-content: flex-start;
}

.icon-group.right {
  justify-content: flex-end;
}

.logo-center {
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  transform: translateX(-50%);
  z-index: 1;
}

.logo-image,
.help-logo-image {
  width: 50px;
  filter: drop-shadow(0 1px 10px rgba(0,0,0,0.18));
  cursor: pointer;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.16s, transform 0.18s;
  opacity: 0.9;
  -webkit-user-select: none;
          user-select: none;
}

.header-icon:hover {
  opacity: 1;
  transform: scale(1.12);
}

.profile-dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
}

.profile-dropdown-menu {
  position: fixed;
  top: 70px;
  right: 0;
  min-width: 200px;
  background: #181818;
  color: #fff;
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  padding: 0.7rem 0.5rem;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.18s;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-8px);}
  to   { opacity: 1; transform: translateY(0);}
}

.menu-item {
  padding: 0.9rem 0.8rem;
  margin: 0.2rem 0;
  cursor: pointer;
  border-radius: 0.7rem;
  font-size: 1.08rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: background 0.14s;
}

.menu-item:hover {
  background: rgba(236, 240, 241, 0.13);
}

.menu-item.logout {
  background-color: #e74c3c;
  color: #fff;
  margin-top: 0.5rem;
}

.menu-item.logout:hover {
  background-color: #c0392b;
}

.sidebar-icon {
  margin-right: 8px;
  font-size: 1.3em;
}

.language-dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 1.5rem;
  margin-right: 0.7rem;
}

.language-dropdown-button {
  background: none;
  border: none;
  color: white;
  font-size: 1.15rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.3rem 0.7rem;
  border-radius: 0.8rem;
  transition: background 0.16s;
}

.language-dropdown-button:hover {
  background: rgba(255,255,255,0.11);
}

.language-dropdown-menu {
  position: absolute;
  top: 36px;
  left: 50%;
  transform: translateX(-50%);
  background: #181818;
  border-radius: 0.7rem;
  box-shadow: 0 4px 24px rgba(44, 62, 80, 0.18);
  min-width: 120px;
  padding: 0.2rem 0;
  overflow: hidden;
  z-index: 1200;
}

.language-dropdown-item {
  padding: 0.65rem 1.2rem;
  cursor: pointer;
  font-size: 1rem;
  color: #fff;
  transition: background 0.15s;
  display: flex;
  align-items: center;
}

.language-dropdown-item:hover {
  background: #34495e;
}

.language-flag-icon {
  width: 30px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Header.css"],"names":[],"mappings":"AAAA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;;EAEE,SAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,CAAC;EAC/C,OAAO,UAAU,EAAE,wBAAwB,CAAC;AAC9C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".header-container,\n.no-user-header-container,\n.help-header-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n  background: #181818;\n  height: 70px;\n  padding: 0 2.2rem;\n  box-shadow: 0 2px 16px rgba(0,0,0,0.15);\n  font-family: 'Inter', Arial, sans-serif;\n}\n\n.icon-group.left,\n.icon-group.right {\n  flex: 1 0 0;\n  min-width: 120px;\n  display: flex;\n  align-items: center;\n  gap: 1.1rem;\n}\n\n.icon-group.left {\n  justify-content: flex-start;\n}\n\n.icon-group.right {\n  justify-content: flex-end;\n}\n\n.logo-center {\n  position: absolute;\n  left: 50%;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  transform: translateX(-50%);\n  z-index: 1;\n}\n\n.logo-image,\n.help-logo-image {\n  width: 50px;\n  filter: drop-shadow(0 1px 10px rgba(0,0,0,0.18));\n  cursor: pointer;\n}\n\n.header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: opacity 0.16s, transform 0.18s;\n  opacity: 0.9;\n  user-select: none;\n}\n\n.header-icon:hover {\n  opacity: 1;\n  transform: scale(1.12);\n}\n\n.profile-dropdown-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.profile-dropdown-menu {\n  position: fixed;\n  top: 70px;\n  right: 0;\n  min-width: 200px;\n  background: #181818;\n  color: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.18);\n  padding: 0.7rem 0.5rem;\n  z-index: 1200;\n  display: flex;\n  flex-direction: column;\n  animation: fadeIn 0.18s;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-8px);}\n  to   { opacity: 1; transform: translateY(0);}\n}\n\n.menu-item {\n  padding: 0.9rem 0.8rem;\n  margin: 0.2rem 0;\n  cursor: pointer;\n  border-radius: 0.7rem;\n  font-size: 1.08rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: background 0.14s;\n}\n\n.menu-item:hover {\n  background: rgba(236, 240, 241, 0.13);\n}\n\n.menu-item.logout {\n  background-color: #e74c3c;\n  color: #fff;\n  margin-top: 0.5rem;\n}\n\n.menu-item.logout:hover {\n  background-color: #c0392b;\n}\n\n.sidebar-icon {\n  margin-right: 8px;\n  font-size: 1.3em;\n}\n\n.language-dropdown-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-left: 1.5rem;\n  margin-right: 0.7rem;\n}\n\n.language-dropdown-button {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.15rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0.3rem 0.7rem;\n  border-radius: 0.8rem;\n  transition: background 0.16s;\n}\n\n.language-dropdown-button:hover {\n  background: rgba(255,255,255,0.11);\n}\n\n.language-dropdown-menu {\n  position: absolute;\n  top: 36px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #181818;\n  border-radius: 0.7rem;\n  box-shadow: 0 4px 24px rgba(44, 62, 80, 0.18);\n  min-width: 120px;\n  padding: 0.2rem 0;\n  overflow: hidden;\n  z-index: 1200;\n}\n\n.language-dropdown-item {\n  padding: 0.65rem 1.2rem;\n  cursor: pointer;\n  font-size: 1rem;\n  color: #fff;\n  transition: background 0.15s;\n  display: flex;\n  align-items: center;\n}\n\n.language-dropdown-item:hover {\n  background: #34495e;\n}\n\n.language-flag-icon {\n  width: 30px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
